import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TOnCallTeamMembersArray } from "../../Types";
import { post } from "../axios-post";

export const apiGetOnCallTeamMembers = async (): Promise<{
  data: TOnCallTeamMembersArray;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    data: TOnCallTeamMembersArray;
  }>(`developer/getOnCallTeamMembers`, {});

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [
        {
          id: 0,
          team: "SE",
          name: "",
          phoneNumber: "",
          email: "",
          onDuty: 0
        }
      ],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
